import React, { useEffect, useState } from 'react';
import { AppBar, Avatar, Typography, MenuItem, Select, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { useSelector, useDispatch } from 'react-redux';
import { setEmpresa } from '../../store/actions/fuse/empresa.actions';
import * as Actions from "app/store/actions";
import CompanyService from 'app/services/CompanyService';

const useStyles = makeStyles(theme => ({
    root: {
        '&.user': {
            '& .username, & .email': {
                transition: theme.transitions.create('opacity', {
                    duration: theme.transitions.duration.shortest,
                    easing: theme.transitions.easing.easeInOut
                })
            }
        }
    },
    avatar: {
        width: 72,
        height: 72,
        position: 'absolute',
        top: 92,
        padding: 8,
        background: theme.palette.background.default,
        boxSizing: 'content-box',
        left: '50%',
        transform: 'translateX(-50%)',
        transition: theme.transitions.create('all', {
            duration: theme.transitions.duration.shortest,
            easing: theme.transitions.easing.easeInOut,
        }),
        '& > img': {
            borderRadius: '50%'
        }
    },
    select: {
        marginTop: 10,
        background: theme.palette.background.default,
        borderRadius: 4,
        padding: 4
    }
}));

function UserNavbarHeader(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const dispatchMsg = useDispatch();

    const user = useSelector(({ auth }) => auth.user);
    const userProfile = user.role[0];
    const [empresas, handleEmpresas] = useState([]);

    function message(type = "null", message = "") {
        dispatchMsg(
            Actions.showMessage({
                message: message,
                autoHideDuration: 6000, //ms
                anchorOrigin: {
                    vertical: "top", //top bottom
                    horizontal: "center" //left center right
                },
                variant: type //success error info warning null
            })
        );
    }

    useEffect(() => {
        fetchEmpresas()
    }, []);

    const fetchEmpresas = async () => {

        let result = {}

        if (userProfile == 'admin') {
            result = await CompanyService.getCompanyAll();
        } else if (userProfile == 'rh' || userProfile == 'director' || userProfile == 'master') {
            result = {
                data: {
                    status: 'success',
                    data: user.data.empresas
                }
            };
        }

        if (result.data && result.data.status === 'success') {
            handleEmpresas(result.data.data);

            if (result.data.data.length == 0) {
                setTimeout(() => {
                    message("error", "No tienes empresas asignadas");
                }, 1000);

            }
        }
    }

    // Empresa seleccionada
    const empresaSeleccionada = useSelector(state => state.fuse.empresa?.empresaSeleccionada || null);

    // Manejador de cambios en el select
    const handleEmpresaChange = (event) => {
        const nuevaEmpresa = event.target.value;
        dispatch(setEmpresa(nuevaEmpresa)); // Actualiza Redux y LocalStorage
    };

    return (
        <AppBar
            position="static"
            color="primary"
            elevation={0}
            classes={{ root: classes.root }}
            className="user relative flex flex-col items-center justify-center pt-24 pb-64 mb-32 z-0"
        >
            <Typography className="username text-16 whitespace-no-wrap" color="inherit">{user.data.displayName}</Typography>
            <Typography className="email text-13 mt-8 opacity-50 whitespace-no-wrap" color="inherit">{user.data.email}</Typography>

            {userProfile === 'admin' || userProfile == 'director' || userProfile == 'rh' || userProfile == 'master' ?
                < Select
                    value={empresaSeleccionada || ''}
                    onChange={handleEmpresaChange}
                    className={classes.select}
                    variant="outlined"
                    displayEmpty
                >
                    <MenuItem value="">Selecciona una empresa</MenuItem>
                    {empresas && empresas.map((empresa) => (
                        <MenuItem key={empresa.id} value={empresa.id}>{empresa.razon_social}</MenuItem>
                    ))}
                </Select>
                :
                <Avatar
                    className={clsx(classes.avatar, "avatar")}
                    alt="user photo"
                    src={user.data.photoURL && user.data.photoURL !== '' ? user.data.photoURL : "/assets/images/avatars/profile.jpg"}
                />
            }

        </AppBar >
    );
}

export default UserNavbarHeader;
